<div class="produit-complementaire-panneau">

  <div class="produit-complementaire-barre-outils">
    <yo-button
      tooltip="Ajouter des produits complémentaires"
      iconClass="fas fa-plus"
      [theme]="ButtonThemeEnum.ADD"
      (onClick)="openDialogAjout()"
      [disabled]="!canEdit()">
    </yo-button>

    <div class="produit-complementaire-barre-outils-actions">
      <dx-text-box
        mode="search"
        placeholder="Recherche"
        valueChangeEvent="change"
        [width]="250"
        (onValueChanged)="onSearchChanged($event)">
      </dx-text-box>

      <yo-button
        tooltip="Enregistrer"
        type="submit"
        iconClass="fas fa-save"
        [theme]="ButtonThemeEnum.SAVE"
        (onClick)="save()"
        [disabled]="!canEdit() || !hasChanges()">
      </yo-button>
    </div>
  </div>

  <yo-produit-complementaire-grid
    [produitComplementaireList]="produitComplementaireList()"
    [editable]="canEdit()"
    noDataText="Aucun produit complémentaire lié"
    suppressionTooltip="Supprimer le produit du point de livraison"
    (periodeClick)="openDialogPeriode($event)"
    (suppressionClick)="supprimer($event)"
    (jourClick)="toggleJour($event)"
    (ligneEditee)="onLigneEditee()">
  </yo-produit-complementaire-grid>

  <dx-pagination
    class="produit-complementaire-pager"
    [pageSize]="PAGE_SIZE"
    [itemCount]="totalElements()"
    [pageIndex]="currentPage()"
    (pageIndexChange)="onPageIndexChange($event)"
    [showInfo]="true"
    [showNavigationButtons]="true"
    [showPageSizeSelector]="false"
    infoText="Page {0} sur {1} ({2} produits)">
  </dx-pagination>
</div>

<yo-dialog-ajout-produit-complementaire
  [(visible)]="dialogAjoutVisible">
</yo-dialog-ajout-produit-complementaire>

<yo-dialog-periode-conditionnement
  [(visible)]="dialogPeriodeVisible"
  [produit]="produitPeriode()"
  (periodeListChange)="onPeriodeListChange($event)">
</yo-dialog-periode-conditionnement>
